import { useState } from 'react';
import DefaultButton from './DefaultButton';
import { theme } from '../component-library';

const FullscreenButton = () => {
  const [fullscreenMode, setFullscreenMode] = useState(false);

  const enterFullscreen = () => {
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen();
    } else if (document.documentElement.mozRequestFullScreen) {
      document.documentElement.mozRequestFullScreen();
    } else if (document.documentElement.webkitRequestFullscreen) {
      document.documentElement.webkitRequestFullscreen();
    } else if (document.documentElement.msRequestFullscreen) {
      document.documentElement.msRequestFullscreen();
    }
    setFullscreenMode(true);
  };

  function exitFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
    setFullscreenMode(false);
  }

  return (
    <DefaultButton
      type='icon'
      width='240px'
      uppercase
      icon={fullscreenMode ? 'shrink' : 'enlarge'}
      onClick={fullscreenMode ? exitFullscreen : enterFullscreen}
      text={`${fullscreenMode ? 'Exit' : 'Enter'} Full Screen`}
      bg={theme.colors.primary}
    />
  );
};

export default FullscreenButton;
